<template>
  <div class="demo">
    <div class="content">
      <div class="block" v-intersection="{ handler: yourFn, options: options }" :style="{backgroundColor:color}"></div>
      <div class="block"></div>
    </div>
    <span class="tip button" :class="isShow ? 'green' : 'red'">
      ratio:{{ ratio }}
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: "???",
      ratio: 0,
      options: {
        ///threshold:[0.01,0.02,...0.99,1.00]
        threshold: Array.from(
          { length: 100 },
          (_, i) => ((i + 1) / 100).toFixed(2) * 1
        ),
      },
 
      rgbfrom: [69, 104, 220],
      rgbto: [253, 84, 87],
    };
  },
  computed: {
    color() {
      let arr = [];
      this.rgbfrom.forEach((e, i) => {
        let elInRt = this.rgbto[i];
        let Diff = (elInRt - e) * this.ratio;
        arr.push(Math.floor(e + Diff));
      });

      return `rgb( ${arr.join(",")}) `;
    },
  },
  methods: {
    yourFn(entries) {
      this.ratio = entries[0].intersectionRatio.toFixed(4);
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  height: 25vh;
}
</style>
